/* eslint-disable import/no-cycle */
import api from './api.service';

function propagandistReportBookedOrders(params) {
  return api.get('/campaigns/report/propagandists-booked-orders', params);
}

function create(params) {
  return api.post('/campaigns/report/propagandists-booked-orders', params);
}

export const ordersService = {
  propagandistReportBookedOrders,
  create,
};
